import { render, staticRenderFns } from "./BotView.vue?vue&type=template&id=2d1b0137&scoped=true"
import script from "./BotView.vue?vue&type=script&lang=js"
export * from "./BotView.vue?vue&type=script&lang=js"
import style0 from "./BotView.vue?vue&type=style&index=0&id=2d1b0137&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d1b0137",
  null
  
)

export default component.exports